/** "1,234 credits" — credits never carry a $ sign (spec §2 rule 5). */
export function formatCreditsWithUnit(n) {
    if (n == null || !Number.isFinite(Number(n)))
        return '—';
    const v = Number(n);
    const text = v.toLocaleString('en-US', { minimumFractionDigits: 0, maximumFractionDigits: 2 });
    return `${text} ${Math.abs(v) === 1 ? 'credit' : 'credits'}`;
}
